import { Component } from 'react'
import { Spinner, SpinnerProps } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { Box, InfoBox } from 'stylewhere/components'
import { Encodings } from 'stylewhere/api'
import { T, __ } from 'stylewhere/i18n'
import { get as _get } from 'lodash'
import { DEFAULT_PRODUCTION_ORDER_ATTRIBUTES } from './encoding/EncodingForm'

const SpinnerComponent = Spinner as React.ComponentType<SpinnerProps>

interface Props {
  code?: string
  initialType?: string
  operationId?: string
}

interface State {
  order?: any
  loading: boolean
  viewProductionOrderAttribute: boolean
}

export class ProductInfoBoxOrder extends Component<Props, State> {
  init = false

  state: State = {
    order: undefined,
    loading: false,
    viewProductionOrderAttribute: false
  }

  active = () => {
    const { initialType } = this.props
    return ['wam', 'identifierOrderRow'].includes(initialType)
  }

  componentDidMount() {
    const { code, operationId } = this.props
    if (this.active() && operationId && code && !this.init) {
      this.init = true
      this.setState({ loading: true }, this._init)
    }
  }

  _init = async () => {
    const { code, operationId } = this.props
    if (this.active() && operationId && code) {
      try {
        const res = await Encodings.findOrder(operationId, code)
        if (res) {
          this.setState({ order: res, loading: false })
        } else {
          this.setState({ loading: false })
        }
      } catch (e) {
        this.setState({ loading: false })
      }
    }
  }

  static Field = ({ label, value = '---' }: { label?: string; value?: string }) => (
    <ContainerValue row>
      <LabelText data-testid="label-text">{label}</LabelText>
      <ValueText data-testid="value-text">{value}</ValueText>
    </ContainerValue>
  )

  getAttributeValue = (key: string) => {
    const { order } = this.state
    if (order) {
      const value = _get(order, key)
      return value ?? '---'
    }
    return '---'
  }

  getBoxTitle = () => {
    return __(T.misc.production_order)
  }

  getOrderCode = () => {
    return 'productionOrder.code'
  }

  getAttributes = () => {
    return [
      {
        label: __(T.misc.order_type),
        path: 'productionOrder.orderType'
      }
    ]
  }

  managerViewProductionOrderAttribute = () => {
    this.setState({ viewProductionOrderAttribute: !this.state.viewProductionOrderAttribute })
  }

  getProductionOrderAttributes = () => {
    const { viewProductionOrderAttribute } = this.state
    if (viewProductionOrderAttribute) {
      return this.getAttributes()
    }
    return this.getAttributes().slice(0, DEFAULT_PRODUCTION_ORDER_ATTRIBUTES)
  }

  render() {
    const { order, loading } = this.state
    return !loading && order ? (
      <CardContainerOrder data-testid={`product-info-box-order`} data-cy={order.productionOrder?.code}>
        <InfoBox
          title={this.getBoxTitle()}
          subtitle={this.getAttributeValue(this.getOrderCode())}
          data={order}
          fields={this.getProductionOrderAttributes()}
          showMore={
            this.getAttributes().length > DEFAULT_PRODUCTION_ORDER_ATTRIBUTES
              ? () => this.managerViewProductionOrderAttribute()
              : undefined
          }
          viewMore={this.state.viewProductionOrderAttribute}
          style={{ padding: 0, boxShadow: 'unset' }}
        />
      </CardContainerOrder>
    ) : loading ? (
      <CardContainerOrder center>
        <SpinnerComponent color="#454545" />
      </CardContainerOrder>
    ) : null
  }
}

const CardContainerOrder = styled(Box)`
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 20px;
  margin: 0px;
  margin-bottom: 10px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
`
const ContainerValue = styled(Box)`
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 10px;
  padding-bottom: 10px;
  &:last-child {
    border-bottom: 0 solid #e0e0e0;
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
`
const LabelText = styled.div`
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
`
const ValueText = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: right;
`
